/**
 * Compute likelihood ratios from sens/spec percentages.
 * Returns null when not enough data, infinity when spec=100, etc.
 *
 * LR+ = sens / (1 - spec)
 * LR- = (1 - sens) / spec
 *
 * Interpretation (Jaeschke et al. 1994):
 *   LR+  >10   strong rule-in
 *   LR+  5-10  moderate
 *   LR+  2-5   weak
 *   LR-  <0.1  strong rule-out
 *   LR-  0.1-0.2  moderate
 *   LR-  0.2-0.5  weak
 */
export function computeLR(sens, spec) {
  if (sens == null || spec == null) return { lrPos: null, lrNeg: null };
  const se = sens / 100;
  const sp = spec / 100;
  const lrPos = sp >= 1 ? Infinity : se / (1 - sp);
  const lrNeg = sp <= 0 ? Infinity : (1 - se) / sp;
  return { lrPos, lrNeg };
}

export function fmtLR(v) {
  if (v == null) return "—";
  if (!isFinite(v)) return "∞";
  if (v >= 10) return v.toFixed(1);
  if (v >= 1) return v.toFixed(1);
  return v.toFixed(2);
}

/**
 * Returns a tailwind text-color class indicating diagnostic strength.
 * Strong = green/primary, moderate = accent, weak = muted.
 */
export function lrPosColor(v) {
  if (v == null || !isFinite(v)) return "text-muted-foreground";
  if (v >= 10) return "text-primary";
  if (v >= 5) return "text-accent";
  return "text-muted-foreground";
}

export function lrNegColor(v) {
  if (v == null) return "text-muted-foreground";
  if (v <= 0.1) return "text-primary";
  if (v <= 0.2) return "text-accent";
  return "text-muted-foreground";
}
